import type { Technician } from '@/api/orders'
import { stripTechnicianNoPrefix } from '@/utils/technicianNoFromList'
import {
  INSPECTOR_DOT_ICONS,
  INSPECTOR_PIN_ICONS,
} from '../constants'
import imgInspectorPinBlue from '@/assets/pin备份 8@2x.png'

export type ScheduleTechnician = Technician & { staffNo?: string; linkedIds?: string[] }

export function dedupeTechniciansByNameAndStaffNo(
  list: (Technician & { staffNo?: string })[],
): ScheduleTechnician[] {
  const byKey = new Map<string, ScheduleTechnician>()
  for (const t of list) {
    const name = t.name.trim()
    if (!name) continue
    const staffNo = stripTechnicianNoPrefix(t.staffNo) ?? ''
    const key = `${name.toLowerCase()}|${staffNo.toLowerCase()}`
    const existing = byKey.get(key)
    if (!existing) {
      byKey.set(key, { ...t, name, staffNo: staffNo || undefined, linkedIds: [t.id] })
      continue
    }
    const ids = new Set([...(existing.linkedIds ?? [existing.id]), t.id])
    existing.linkedIds = [...ids]
  }
  return [...byKey.values()]
}

export function inspectorVisualsForIndex(i: number): {
  dotIcon: string
  pinIcon: string
  visualTone: number
} {
  const visualTone = i % INSPECTOR_DOT_ICONS.length
  return {
    visualTone,
    dotIcon: INSPECTOR_DOT_ICONS[visualTone]!,
    pinIcon: INSPECTOR_PIN_ICONS[visualTone]!,
  }
}

/** 检查员姓名左侧圆点：选中 #00AEEF；有单 #D9F0FF；无单 #98D5BE */
export function inspectorDotColor(orderCount: number, selected: boolean): string {
  if (selected) return '#00AEEF'
  if (orderCount === 0) return '#98D5BE'
  return '#D9F0FF'
}

export function assignmentPinMaskStyle(color: string): Record<string, string> {
  return {
    WebkitMaskImage: `url(${imgInspectorPinBlue})`,
    maskImage: `url(${imgInspectorPinBlue})`,
    backgroundColor: color,
  }
}

export function formatAssignmentOrderId(orderId: string): string {
  const id = orderId.trim()
  if (!id) return ''
  return id.startsWith('#') ? id : `#${id}`
}
